import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from "../../assets/images/Logo-New.png";
import rawMenuData from "./MenuData";
import { useHiddenCategories, filterMenu } from "../../api/hiddenCategories";
import MobileMenu from "./MobileMenu";
import { Link, useNavigate, useLocation } from "react-router-dom";
import MegaMenu from "./MegaMenu";
import SearchBar from "./SearchBar";
import AnnouncementBar from "../AnnouncementBar/AnnouncementBar";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { FaGlobe } from "react-icons/fa";
import { LANGUAGES, setPageLanguage } from "../../utils/pageTranslate";
import { FiShoppingCart } from "react-icons/fi";
import { useCart } from "../../context/CartContext";
import CartDrawer from "../Cart/CartDrawer";
import {
  FaBars,
  FaUser,
  FaChevronDown,
} from "react-icons/fa";

const Header = () => {
  const {
  cartCount,
  setIsCartOpen,
} = useCart();
  const hiddenCategories = useHiddenCategories();
  const menuData = filterMenu(rawMenuData, hiddenCategories);
  const [activeMenu, setActiveMenu] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close the dropdown whenever the route changes so it never stays stuck open
  useEffect(() => {
    setActiveMenu(null);
  }, [location.pathname]);

  const { t, i18n } = useTranslation();

  // Navigate
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
    setPageLanguage(lang);
  };

  // User Account
  const handleAccountClick = () => {
    if (isLoggedIn) {
      navigate("/account");
    } else {
      navigate("/login", { state: { redirectTo: "/account" } });
    }
  };

  // Cart
  const handleCartClick = () => {
    navigate("/cart");
  };

  return (
    <>
  
      <div className="offerbar">
        <div className="offerbar-wrapper">

          {/* Left - Language */}
          <div className="languageBox">
            <FaGlobe className="globeIcon" />

            <select
              value={i18n.language}
              onChange={(e) => changeLanguage(e.target.value)}
              translate="no"
            >
              {LANGUAGES.map(({ code, label }) => (
                <option key={code} value={code}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          <div className="offerbar-text">
            {t("healthy")}
          </div>
      <AnnouncementBar />


        </div>
      </div>

      {/* =========================
          MAIN HEADER
      ========================== */}

      <div className="topHeader">

        {/* LOGO */}
        <div className="logoArea">
          <img src={logo} alt="Astro Logical Solutions" />

          <div className="companyName">
            <h2>Astro Logical™ Solutions</h2>
            <p>Healthy • Vedic • Lifestyle</p>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="topRight">

          {/* SEARCH */}
          <SearchBar />

          {/* USER ACCOUNT */}
          <button
            type="button"
            className="cartIcon"
            onClick={handleAccountClick}
            aria-label="My Account"
            title="My Account"
          >
            <FaUser />
          </button>

          {/* CART */}
       <div className="header-cart-wrapper">
  <button
    type="button"
    className="header-cart-btn"
    onClick={() => setIsCartOpen(true)}
  >
    <FiShoppingCart />

    {cartCount > 0 && (
      <span className="header-cart-count">
        {cartCount}
      </span>
    )}
  </button>
</div>

<CartDrawer />

        </div>
      </div>

      {/* =========================
          NAVBAR
      ========================== */}

      <nav className="navbar">

        {/* MOBILE MENU */}
        <div
          className="mobileMenu"
          onClick={() => setIsOpen(true)}
        >
          <FaBars />
        </div>

        <ul>
          {menuData.map((menu, index) => (

            <li
              key={index}
              onMouseEnter={() => setActiveMenu(index)}
              onMouseOver={() =>
                setActiveMenu((prev) => (prev === index ? prev : index))
              }
              onMouseLeave={() => setActiveMenu(null)}
            >

              <Link
                to={menu.link || "#"}
                className="navLink"
                onClick={(e) => {
                  if (menu.megaMenu) {
                    // "The Shoppe" has no page of its own - toggle the
                    // dropdown instead of navigating to "#".
                    e.preventDefault();
                    setActiveMenu((prev) => (prev === index ? null : index));
                  } else {
                    setActiveMenu(null);
                  }
                }}
              >
                <span>{menu.title}</span>

                {menu.megaMenu && (
                  <FaChevronDown className="downIcon" />
                )}
              </Link>

              {/* MEGA MENU */}

              {menu.megaMenu &&
                activeMenu === index && (
                  <MegaMenu
                    categories={menu.categories}
                    onNavigate={() => setActiveMenu(null)}
                  />
                )}

            </li>

          ))}
        </ul>
      </nav>

      {/* MOBILE MENU COMPONENT */}

      <MobileMenu
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </>
  );
};

export default Header;